/* Change this file to get your personal Portfolio */

// To change portfolio colors globally go to the  _globalColor.scss file

import emoji from "react-easy-emoji";
import splashAnimation from "./assets/lottie/splashAnimation"; // Rename to your file name for custom animation

// Splash Screen

const splashScreen = {
  enabled: true, // set false to disable splash screen
  animation: splashAnimation,
  duration: 1000 // Set animation duration as per your animation
};

// Summary And Greeting Section

const illustration = {
  animated: true // Set to false to use static SVG
};

const greeting = {
  username: "Ananya Singh",
  title: "Hello, I'm Ananya",
  subTitle: emoji(
    "Driven by the challenge of pushing AI beyond the lab and into real-world systems that impact lives, I am a graduate student with 2 years of research experience, interested in Machine Learning and AI Engineer roles."
  ),
  resumeLink:
    "https://drive.google.com/file/d/1v-0l-WBKqDaoIBrGaSbnWpf1H2bINE1l/view?usp=sharing", // Set to empty to hide the button
  displayGreeting: true // Set false to hide this section, defaults to true
};

// Social Media Links

const socialMediaLinks = {
  github: "https://github.com/ananya4150",
  linkedin: "https://www.linkedin.com/in/singhananyaoh",
  gmail: "ananya4150@gmail.com",
  gitlab: "https://gitlab.oit.duke.edu/as1716",
  medium: "https://medium.com/@asingh44_be21",
  // Instagram, Twitter and Kaggle are also supported in the links!
  // To customize icons and social links, tweak src/components/SocialMedia
  display: true // Set true to display this section, defaults to false
};

// Skills Section

const skillsSection = {
  title: "What I do",
  subTitle: "I work at the intersection of machine learning research, systems engineering, and real-world deployment. I enjoy taking ideas from mathematical foundations to practical ML systems, whether that means building models for healthcare, optimizing computer vision for edge devices, or designing data pipelines that make AI applications reliable and usable.\n\nI’m especially interested in problems that start with curiosity and end with something that works beyond a paper.",
  skills: [
    emoji(
      "➤ Build and optimize deep learning models for real-world constraints, including edge and resource-limited environments"
    ),
    emoji(
      "➤ Design ML pipelines that connect data processing, model development, and deployment-ready systems"
    ),
    emoji(
      "➤ Work on research-driven projects across healthcare AI, computer vision, time-series modeling, and ML infrastructure"
    )
  ],



  softwareSkills: [
    {
      skillName: "python",
      fontAwesomeClassname: "fab fa-python"

    },
    {
      skillName: "pandas",
      fontAwesomeClassname: "devicon-pandas-plain"
    },
    {
      skillName: "numpy",
      fontAwesomeClassname: "devicon-numpy-plain"
    },
    {
      skillName: "matplotlib",
      fontAwesomeClassname: "devicon-matplotlib-plain"
    },
    {
      skillName: "opencv",
      fontAwesomeClassname: "devicon-opencv-plain"
    },
    {
      skillName: "Tensorflow",
      fontAwesomeClassname: "devicon-tensorflow-original"
    },

    {
      skillName: "git",
      fontAwesomeClassname: "devicon-git-plain"
    },
    {
      skillName: "sql-database",
      fontAwesomeClassname: "fas fa-database"
    },
    {
      skillName: "matlab",
      fontAwesomeClassname: "devicon-matlab-plain"
    },
    {
      skillName: "Kubernetes",
      fontAwesomeClassname: "devicon-kubernetes-plain"
    },
    {
      skillName: "Amazon S3",
      fontAwesomeClassname: "fab fa-aws"
    },
    {
      skillName: "Linux",
      fontAwesomeClassname: "fab fa-linux"
    },
    {
      skillName: "Docker",
      fontAwesomeClassname: "fab fa-docker"
    },
    {
      skillName: "PostgreSQL",
      fontAwesomeClassname: "devicon-postgresql-plain"
    },
    {
      skillName: "MongoDB",
      fontAwesomeClassname: "devicon-mongodb-plain"
    },
    {
      skillName: "Apache Airflow",
      fontAwesomeClassname: "fas fa-wind"
    },
    {
      skillName: "YAML",
      fontAwesomeClassname: "fas fa-file-code"
    }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Education Section

const educationInfo = {
  display: true, // Set false to hide this section, defaults to true
  schools: [
    {
      schoolName: "Duke University",
      logo: require("./assets/images/Duke_University.png"),
      subHeader: "Master of Science in Machine Learning & Big Data",
      duration: "August 2025 - April 2027",
      desc: "Focused on machine learning systems and mathematical foundations of ML.",
      descBullets: [
        "3.9 / 4 GPA",
        "Recipient of a merit-based scholarship"
      ]
    },
    {
      schoolName: "University of Toledo",
      logo: require("./assets/images/universityoftoledologo-png.png"),
      subHeader: "Bachelor of Science in Computer Science and Engineering",
      duration: "May 2023 - August 2025",
      desc: "Undergraduate studies with a strong focus on machine learning, systems, and applied research.",
      descBullets: [
        "GPA: 3.88 / 4.00",
        "IEEE Student of the Year (Computer Science Engineering)",
        "International Rocket Scholarship recipient"

      ]
    }
  ]
};

// Your top 3 proficient stacks/tech experience

const techStack = {
  viewSkillBars: true, //Set it to true to show Proficiency Section
  experience: [
    {
      Stack: "Python", //Insert stack or technology you have experience in
      progressPercentage: "90%" //Insert relative proficiency in percentage
    },
    {
      Stack: "Machine Learning & Modeling",
      progressPercentage: "80%"
    },
    {
      Stack: "Systems & Integration",
      progressPercentage: "80%"
    }
  ],
  displayCodersrank: false // Set true to display codersrank badges section need to changes your username in src/containers/skillProgress/skillProgress.js:17:62, defaults to false
};

// Work experience section

const workExperiences = {
  display: false, //Set it to true to show workExperiences Section
  experience: [
    {
      role: "Software Engineer",
      company: "Facebook",
      companylogo: require("./assets/images/facebookLogo.png"),
      date: "June 2018 – Present",
      desc: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
      descBullets: [
        "Lorem ipsum dolor sit amet, consectetur adipiscing elit",
        "Lorem ipsum dolor sit amet, consectetur adipiscing elit"
      ]
    },
    {
      role: "Front-End Developer",
      company: "Quora",
      companylogo: require("./assets/images/quoraLogo.png"),
      date: "May 2017 – May 2018",
      desc: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua."
    },
    {
      role: "Software Engineer Intern",
      company: "Airbnb",
      companylogo: require("./assets/images/airbnbLogo.png"),
      date: "Jan 2015 – Sep 2015",
      desc: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua."
    }
  ]
};

/* Your Open Source Section to View Your Github Pinned Projects
To know how to get github key look at readme.md */



// Some big projects you have worked on

const bigProjects = {
  title: "Research Experience",
  subtitle: "I am drawn to the process of research: deep reading, long hours of experimentation, and the excitement of refining ideas through discussion and discovery.Below are a few of my research works.",
  projects: [
    {
      image: require("./assets/images/wildfire2.png"),
      projectName: "Wildfire",
      projectDesc: "I worked on applying machine learning and AIoT techniques to real-world wildfire monitoring and detection problems.",
      projectDetails: `• Secured $3,000 in research funding through a self-authored proposal on wildfire detection using YOLO and model optimization techniques \n
• Engineered a drone-based wildfire simulation testbed by integrating simulation environments and flight-control tools, enabling systematic benchmarking of detection models\n
• Optimized computer vision models in Python, reducing model size by ~50% while maintaining 99.58% accuracy, contributing as second author to an IEEE publication
\n• Collaborated on peer-reviewed research papers and technical proposals, contributing multiple sections focused on methodology and system design
\n• Researched AIoT curricula and designed sample assignments that informed the development of a new course proposal
`,
      footerLink: [
        {
          name: "Visit Paper",
          url: "https://ieeexplore.ieee.org/document/10811358"
        }
        //  you can add extra buttons here.
      ]
    },
    {
      image: require("./assets/images/adaptiveai2.png"),
      projectName: "Adaptive AI",
      projectDesc: "Focused on applying knowledge tracing and explainable AI techniques to build transparent, adaptive educational systems.",
      projectDetails: `• Co-authored research exploring AI-driven adaptive learning systems using knowledge tracing models
\n• Applied explainable AI methods to improve interpretability of student performance predictions
\n• Contributed to the methodological foundation for transparent, data-driven education platforms
`,
      footerLink: [
        {
          name: "Visit Paper",
          url: "https://nemo.asee.org/public/conferences/365/papers/49113/view"
        }
      ]
    }
  ],
  display: true // Set false to hide this section, defaults to true
};



const openSource = {
  showGithubProfile: "false", // Set true or false to show Contact profile using Github, defaults to true
  display: false // Set false to hide this section, defaults to true
};

// Projects Section
const minProjects = {
  title: "Projects",
  subtitle: "Here are some of my other projects.",
  achievementsCards: [
    {
      title: "Parkinson’s Disease Severity System",
      subtitle: "",
      projectDetails: "• Built an end-to-end Parkinson’s disease progression prediction system using LLM, RAG, Transformer, and LSTM models on 37K+ longitudinal PPMI patient-visit records; enabled earlier next-visit risk forecasting to support proactive treatment planning.\n• Developed a missingness-aware clinical inference pipeline with temporal feature engineering and RAG based explanation generation; converted fragmented multi-visit data into consistent severity predictions and Human-Readable outputs.",
      image: require("./assets/images/parkinson_new.jpg"),
      imageAlt: "Project Logo",
      footerLink: [
        { name: "View Project", url: "https://github.com/ananya4150/Parkinson-s-Next-Visit-UPDRS-Forecasting" }
      ]
    },
    {
      title: "Market Sentiment and Insider Trade Analysis",
      subtitle: "",
      projectDetails: "• Engineered an end-to-end market sentiment pipeline deployed on Kubernetes, leveraging Airflow, PostgreSQL, and MinIO to handle API ingestion, deduplication, and normalization of Alpha Vantage news, data; delivered personalized HTML emails with ticker-level sentiment signals.",
      image: require("./assets/images/sentiment.jpg"),
      imageAlt: "Project Logo",
      footerLink: [
        { name: "View Project", url: "https://github.com/ananya4150/Market-Sentiment-and-Insider-Trade-Analysis" }
      ]
    },
    {
      title: "Global recipe and meals planner",
      subtitle: "",
      projectDetails: "• Built a Python application integrating the MealDB API, leveraging object-oriented programming, abstraction, and modular design, and contributing to collaborative team development and organization.",
      image: require("./assets/images/global_recipe_new.jpg"),
      imageAlt: "Project Logo",
      footerLink: [
        { name: "View Project", url: "https://github.com/ananya4150/Global-recipe-and-meals-planner" }
      ]
    },
    {
      title: "Astrophotography Error Classifier",
      subtitle: "",
      projectDetails: "• Developed a data driven computer vision pipeline for astronomical imagery through experimentation with debayering, normalization, augmentation, and star-level ROI extraction to isolate shape distortions\n• Trained and benchmarked deep CNNs in PyTorch from scratch to classify focus, tracking, wind, and exposure errors, achieving 95% test accuracy.",
      image: require("./assets/images/astro_new.jpg"),
      imageAlt: "Project Logo",
      footerLink: [
        { name: "View Project", url: "https://drive.google.com/file/d/12BsP-JDeiUnXrOR0J3btOtqX2KjD_Y81/view?usp=sharing" }
      ]
    },
    {
      title: "Library Management System",
      subtitle: "",
      projectDetails: "• Implemented a Python object-oriented library system from a UML class design, modeling patrons, books, checkout workflows, and availability tracking through modular classes and reusable interfaces.",
      image: require("./assets/images/library.jpg"),
      imageAlt: "Project Logo",
      footerLink: [
        { name: "View Project", url: "https://github.com/ananya4150/Library-Management-System" }
      ]
    },
    {
      title: "College Recommendation System (UniMatch)",
      subtitle: "",
      projectDetails: "• Developed an Elasticsearch-based recommendation system to match students to colleges on personalized criteria, reducing retrieval time and improving relevance.\n• Collected and analyzed college reviews with sentiment analysis, classifying and summarizing",
      image: require("./assets/images/unimatch_new.jpg"),
      imageAlt: "Project Logo",
      footerLink: [
        { name: "View Project", url: "https://www.canva.com/design/DAG91DJGKIw/PLaJ5CXFyQldqlnNW9ahMg/edit?utm_content=DAG91DJGKIw&utm_campaign=designshare&utm_medium=link2&utm_source=sharebutton" }
      ]
    },
    {
      title: "Diabetic Retinopathy Detection",
      subtitle: "",
      projectDetails: "• Preprocessed complex data,retina images with gamma correction and CLAHE to improve brightness, then extracted features with deep learning , achieving 96% accuracy using Logistic Regression and classical.",
      image: require("./assets/images/diabetic_new.jpg"),
      imageAlt: "Project Logo",
      footerLink: [
        { name: "View Project", url: "https://docs.google.com/presentation/d/1S9YNDPJyqjj7ilNb4oTAIHoL9x1xf9cS/edit?usp=sharing&ouid=117289152656669241085&rtpof=true&sd=true" }
      ]
    }
  ],
  display: true
};

// Leadership Experience Section
const leadershipSection = {
  title: "Leadership Experience",
  subtitle: "My experience leading teams and initiatives.",
  achievementsCards: [
    {
      title: "ACM-W — Treasurer",
      subtitle: "Led and instructed multiple outreach workshops introducing high-school girls and underprivileged students to computer science and AI. Actively contributed to school outreach initiatives, focusing on early exposure, hands-on learning, and fostering curiosity in computing.",
      image: require("./assets/images/acm-w.png"),
      imageAlt: "Leadership Logo",
      footerLink: [
        // { name: "View Details", url: "" }
      ]
    },
    {
      title: "ACM — Technical Head",
      subtitle: "Contributed to organizing and executing technical workshops and events, with primary responsibility for event coordination, logistics, and outreach. Supported planning efforts to ensure smooth execution and effective engagement with the student community.",
      image: require("./assets/images/acm.png"),
      imageAlt: "Leadership Logo",
      footerLink: [
        // { name: "View Details", url: "" }
      ]
    },
    {
      title: "Teaching Assistant — University of Toledo",
      subtitle: "Mentored 52 students in IoT and Python by designing lab assignments, leading hands-on sessions, and providing technical guidance to improve overall course performance.",
      image: require("./assets/images/universityoftoledologo-png.png"),
      imageAlt: "Leadership Logo",
      footerLink: []
    },
    {
      title: "Teaching Assistant — UToledo Math Corps",
      subtitle: "Led a team of high school students in a Data Science program, providing mentorship and structured instruction to foster an engaging learning environment and support educational outcomes.",
      image: require("./assets/images/universityoftoledologo-png.png"),
      imageAlt: "Leadership Logo",
      footerLink: []
    }
  ],
  display: true
};

// Achievement Section
// Include certificates, talks etc

const achievementSection = {
  title: emoji("Achievements 🏆 "),
  subtitle:
    "Achievements that I am proud of!",

  achievementsCards: [
    {
      title: "IEEE Student of the Year – Computer Science Engineering ",
      subtitle:
        "Awarded for academic excellence, research contributions, and leadership within the department.",
      image: require("./assets/images/IEEE_logo.svg.png"),
      imageAlt: "IEEE Student of the Year – Computer Science Engineering",
      footerLink: [
        {
          name: "Certification",
          url: "https://drive.google.com/file/d/1skgNDilHIati8LgxprKTweZnbNj5d6zH/view?usp=sharing"
        }
      ]
    },
    {
      title: "Duke Merit Scholarship",
      subtitle:
        "Merit-based scholarship recognizing academic performance and potential in engineering.",
      image: require("./assets/images/Duke_University.png"),
      imageAlt: "Duke Merit Scholarship",
      footerLink: [
        {
          name: "View award letter",
          url: "https://drive.google.com/file/d/1cR1pGXMitDKcwmy2HJY_X0ayCCE8S6BO/view?usp=sharing"
        }
      ]
    },

    {
      title: "Competitive Undergraduate Research Funding",
      subtitle: "Secured funding through a self-authored research proposal to support independent research work.",
      image: require("./assets/images/universityoftoledologo-png.png"),
      imageAlt: "University of Toledo",
      footerLink: [
        { name: "View award letter", url: "https://drive.google.com/file/d/1PNAJdJrNzbdmdtTbJuA7MleSqZl8YYbd/view?usp=sharing" },

      ]
    }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Blogs Section

const blogSection = {
  title: "Blogs",
  subtitle:
    "With Love for Developing cool stuff, I love to write and teach others what I have learnt.",
  displayMediumBlogs: "false", // Set true to display fetched medium blogs instead of hardcoded ones
  blogs: [
    {
      url: "",
      title: "Win a Google Assistant Tshirt and $200 in Google Cloud Credits",
      description:
        "Do you want to win $200 and Google Assistant Tshirt by creating a Google Assistant Action in less then 30 min?"
    },
    {
      url: "#",
      title: "Why REACT is The Best?",
      description:
        "React is a JavaScript library for building User Interface. It is maintained by Facebook and a community of individual developers and companies."
    }
  ],
  display: false // Set false to hide this section, defaults to true
};

// // Talks Sections

const talkSection = {
  title: "TALKS",
  subtitle: emoji(
    "I LOVE TO SHARE MY LIMITED KNOWLEDGE AND GET A SPEAKER BADGE"
  ),

  talks: [
    {
      title: "Build Actions For Google Assistant",
      subtitle: "Codelab at GDG DevFest Karachi 2019",
      slides_url: "#",
      event_url: "#"
    }
  ],
  display: false // Set false to hide this section, defaults to true
};

// Podcast Section

const podcastSection = {
  title: emoji("Podcast 🎙️"),
  subtitle: "I LOVE TO TALK ABOUT MYSELF AND TECHNOLOGY",

  // Please Provide with Your Podcast embeded Link
  podcast: [
    "#"
  ],
  display: false // Set false to hide this section, defaults to true
};

// Resume Section
const resumeSection = {
  title: "Resume",
  subtitle: "Feel free to download my resume",

  // Please Provide with Your Podcast embeded Link
  display: true // Set false to hide this section, defaults to true
};

const contactInfo = {
  title: emoji("Contact Me ☎️"),
  subtitle:
    "Interested in discussing a project, research ideas, or opportunities or just want to say hi? My inbox is always open.",
  number: "",
  email_address: "singhananyaoh@gmail.com"
};

// Twitter Section

const twitterDetails = {
  userName: "twitter", //Replace "twitter" with your twitter username without @
  display: false // Set true to display this section, defaults to false
};

const isHireable = true; // Set false if you are not looking for a job. Also isHireable will be display as Open for opportunities: Yes/No in the GitHub footer

export {
  illustration,
  greeting,
  socialMediaLinks,
  splashScreen,
  skillsSection,
  educationInfo,
  techStack,
  workExperiences,
  openSource,
  bigProjects,
  minProjects,
  leadershipSection,
  achievementSection,
  blogSection,
  talkSection,
  podcastSection,
  contactInfo,
  twitterDetails,
  isHireable,
  resumeSection
};
